import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-anti-ragging-event',
  templateUrl: './anti-ragging-event.component.html',
  styleUrls: ['./anti-ragging-event.component.scss']
})
export class AntiRaggingEventComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
